const digest = 'bf45906fab3eb8d1773a755125f790658438e3e0d6ca79a678e844070f353fbd';
const css = `@media (min-width:768px){._minHeight_1v402_2{min-height:35rem}}@media (min-width:1024px){._minHeight_1v402_2{min-height:31rem}}._travelBenefits_1v402_12{z-index:20}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'minHeight': '_minHeight_1v402_2', 'travelBenefits': '_travelBenefits_1v402_12' };
export const minHeight = '_minHeight_1v402_2';
export const travelBenefits = '_travelBenefits_1v402_12';
export { css, digest };